import { MultiSelectDesignTokens } from '@primeuix/themes/types/multiselect';
import { SM_SIZE_TOKENS } from './sm-size.tokens';

export const MULTISELECT_STYLES: MultiSelectDesignTokens = {
  root: {
    sm: SM_SIZE_TOKENS,
  },
  css: () => `
    /* Keeps line-height proportional to the 13px font-size */
    .p-multiselect-sm .p-multiselect-label {
        line-height: 0.9375rem; /* 15px */
    }

    /* Dropdown option font-size aligned with --p-multiselect-sm-font-size (13px) */
    .p-multiselect-sm .p-multiselect-option {
        font-size: 0.8125rem; /* 13px */
    }

    /* Matches sm option size so the list looks consistent regardless of trigger size */
    .p-multiselect-list-container .p-multiselect-option {
        font-size: 0.8125rem; /* 13px */
    }

    .p-multiselect-overlay {
        .p-multiselect-option {
            font-size: 0.875rem;
        }

        .p-multiselect-filter {
            height: 2.0625rem;
        }
    }`,
};
